<script setup lang="ts">
import { computed } from "vue";
import Text from "@/cms/primitives/Text/Text.vue";
import { LoadingSpinnerProps } from "@/cms/components/LoadingSpinner/LoadingSpinner.types.ts";

const props = defineProps<LoadingSpinnerProps>();

const spinnerClass = computed(() => {
  switch (props.size) {
    case "xl":
      return "w-32 h-32";
    case "lg":
      return "w-16 h-16";
    case "md":
      return "w-12 h-12";
    default:
      return "w-8 h-8";
  }
});

const labelVariant = computed(() => {
  switch (props.size) {
    case "xl":
      return "title1";
    case "lg":
      return "title2";
    case "md":
      return "title3";
    default:
      return "title4";
  }
});
</script>

<template>
  <div class="flex flex-col gap-4 items-center">
    <div
      :class="spinnerClass"
      class="animate-spin border-2 border-gray-700 border-t-transparent rounded-full"
    ></div>
    <Text
      v-if="props.label"
      :variant="labelVariant"
      class="align-center flex gap-2 justify-start"
    >
      <slot name="icon" />
      <span>{{ props.label }}</span>
    </Text>
  </div>
</template>
